import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";

import Signup from "./modules/Signup";
import Auth from "./modules/Auth";
import User from "./modules/User";
import Circle from "./modules/Circle";
import QA from "./modules/QA";
import App from "./modules/app";
import Posts from "./modules/posts";
import createPersistedState from "vuex-persistedstate";
import SsoLogin from "./modules/loginModel";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    Signup,
    Auth,
    User,
    Circle,
    QA,
    App,
    Posts,
    SsoLogin
  },
  strict: debug,
  plugins: debug
    ? [
        createLogger(),
        createPersistedState({ paths: ["User", "Circle.currentCircle"] })
      ]
    : [createPersistedState({ paths: ["User", "Circle.currentCircle"] })]
});



// WEBPACK FOOTER //
// ./src/store/index.js